import PropTypes from 'prop-types';
import styles from './FJCommunityHome.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';
import { AI_COMMUNITY_SIMPLE_TOOLS_LIST } from '../../../../config/dataConfig/FJCommunityData';
import FJToolItem from '../../FJCommonComponent/FJAIToolItem/FJToolItem';
import FJCommunityMixViewList from '../../FJCommonComponent/FJCommunityMixViewList/FJCommunityMixViewList';
import classNames from 'classnames';
import FJConfig from '../../../../config/FJConfig';
import FJFilterTypeContainer from '../../FJCommonComponent/FJFilterType/FJFilterTypeContainer';
import FJAdvertisingContainer from '../FJAdvertising/FJAdvertisingContainer';
const FJCommunityHome = props => {
    const { active, list, getMoreData, pageInfo = {}, embedded, onSeeAllClick } = props;
    const { initLoading, getMoreLoading, hasMore } = pageInfo;
    const _renderAheadChildren = () => {
        return (
            <>
                <FJAdvertisingContainer />
                {!embedded && (
                    <>
                        <div className={styles.tools_header_container}>
                            <div className={styles.title}>{FJLocalStore._('ai-tools')}</div>
                            <div className={styles.see_all} onClick={onSeeAllClick}>
                                {FJLocalStore._('see-all')}
                            </div>
                        </div>
                        <div className={styles.tools_list}>
                            {AI_COMMUNITY_SIMPLE_TOOLS_LIST.map((item, idx) => (
                                <FJToolItem key={idx} data={item} />
                            ))}
                        </div>
                    </>
                )}
                <div className={styles.popular_container}>
                    {!embedded && <div className={styles.title}>{FJLocalStore._('popular')}</div>}
                    {embedded && <FJFilterTypeContainer embedded={true} />}
                </div>
                {!embedded && (
                    <img src={FJConfig.imgPath + 'community/home-bg.png'} alt='home-bg' className={styles.home_bg} />
                )}
            </>
        );
    };
    return (
        <FJCommunityMixViewList
            active={active}
            initLoading={initLoading}
            getMoreLoading={getMoreLoading}
            hasMore={hasMore}
            className={classNames(
                styles.container,
                { [styles.embedded]: embedded },
                active ? styles.show : styles.hide,
            )}
            list={list}
            getMoreData={getMoreData}
            renderAheadChildren={_renderAheadChildren}
        />
    );
};

FJCommunityHome.propTypes = {
    active: PropTypes.bool.isRequired,
    list: PropTypes.array.isRequired,
    getMoreData: PropTypes.func.isRequired,
    pageInfo: PropTypes.object.isRequired,
    embedded: PropTypes.bool,
    onSeeAllClick: PropTypes.func,
};

export default FJCommunityHome;
